import { Routes, Route, Navigate } from "react-router-dom";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "@/components/layout/ProtectedRoute";
import { UpgradePrompt } from "@/components/ui/upgrade-prompt";
import { useAuth } from "@/contexts/AuthContext";
import { OnboardingModal } from "@/components/onboarding/OnboardingModal";
import { WalkthroughProvider } from "@/components/walkthrough/WalkthroughProvider";
import { LandingPage } from "@/pages/LandingPage";
import { LoginPage } from "@/pages/LoginPage";
import { TranslatePage } from "@/pages/TranslatePage";
import { WordBankPage } from "@/pages/WordBankPage";
import { WordDetailPage } from "@/pages/WordDetailPage";
import { ReviewPage } from "@/pages/ReviewPage";
import { CategoriesPage } from "@/pages/CategoriesPage";
import { CategoryDetailPage } from "@/pages/CategoryDetailPage";
import { StudySetsPage } from "@/pages/StudySetsPage";
import { StudySetDetailPage } from "@/pages/StudySetDetailPage";
import { StatsPage } from "@/pages/StatsPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { FeedbackPage } from "@/pages/FeedbackPage";

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background">
        <img src="/logo.svg" alt="Shoresh" className="w-16 h-16 mb-4 animate-pulse" />
        <span className="text-lg font-semibold tracking-tight">Shoresh</span>
        <div className="mt-6 w-8 h-8 border-2 border-primary/20 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }
  if (user) return <Navigate to="/add" replace />;
  return <LandingPage />;
}

function App() {
  return (
    <>
    <UpgradePrompt />
    <Routes>
      <Route path="/" element={<HomeRoute />} />
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <OnboardingModal />
            <WalkthroughProvider>
              <Layout />
            </WalkthroughProvider>
          </ProtectedRoute>
        }
      >
        {/* Primary routes */}
        <Route path="/add" element={<TranslatePage />} />
        <Route path="/words" element={<WordBankPage />} />
        <Route path="/words/:wordId" element={<WordDetailPage />} />
        <Route path="/practice" element={<ReviewPage />} />
        <Route path="/scenarios" element={<StudySetsPage />} />
        <Route path="/scenarios/:studySetId" element={<StudySetDetailPage />} />
        <Route path="/categories" element={<CategoriesPage />} />
        <Route path="/categories/:categoryId" element={<CategoryDetailPage />} />
        <Route path="/stats" element={<StatsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/feedback" element={<FeedbackPage />} />
        {/* Redirects for old routes */}
        <Route path="/translate" element={<Navigate to="/add" replace />} />
        <Route path="/review" element={<Navigate to="/practice" replace />} />
        <Route path="/study-sets" element={<Navigate to="/scenarios" replace />} />
        <Route path="/study-sets/:studySetId" element={<Navigate to="/scenarios" replace />} />
      </Route>
    </Routes>
    </>
  );
}

export default App;
